module.exports = __webpack_public_path__ + "static/media/direct-media-default.968913ba.svg";